import { regexp } from '@web-apps/utils-shared'
import { LinkAPIType } from '@web-apps/utils-types'

const SOCIALS_REG =
  /[^https?:\/\/(www\.)?(linktr\.ee|instagram\.com)\/(#!\/)]?([^\/]+)(\w+)*[\/]?$/

export const isImageURLValid = (link?: string) => {
  return !!link && !link.startsWith('data:')
}

export const proxyImageUrl = (URL: string): string =>
  `/api/proxy?url=${encodeURIComponent(URL)}`

export const cleanSlug = (slug: string) =>
  slug
    .split('?')[0]
    .match(SOCIALS_REG)?.[0]
    .replace(/\/$/, '')
    .replace(/^@/, '')
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const findLinktreeSlug = (instagramData?: any): string | undefined => {
  if (!instagramData) return undefined

  const regex = regexp('linktr.ee/([^?#:]+).*')
  const link = instagramData?.profile.sections?.find(
    (link: { _links?: { about?: LinkAPIType } }) =>
      link._links?.about?.href && regex.test(link._links.about.href)
  )?._links.about.href

  return link && cleanSlug(link)
}
